import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './tax-tariff-tranche.reducer';

export const TaxTariffTranche = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const taxTariffTrancheList = useAppSelector(state => state.taxTariffTranche.entities);
  const loading = useAppSelector(state => state.taxTariffTranche.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tax-tariff-tranche-heading" data-cy="TaxTariffTrancheHeading">
        <Translate contentKey="crawlerBackendApp.taxTariffTranche.home.title">Tax Tariff Tranches</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.taxTariffTranche.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/tax-tariff-tranche/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.taxTariffTranche.home.createLabel">
              Create new Tax Tariff Tranche
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {taxTariffTrancheList && taxTariffTrancheList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('trancheLowerBound')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.trancheLowerBound">
                    Tranche Lower Bound
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trancheLowerBound')} />
                </th>
                <th className="hand" onClick={sort('trancheUpperBound')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.trancheUpperBound">
                    Tranche Upper Bound
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trancheUpperBound')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.taxTariffTranche.productOfferingPrice">
                    Product Offering Price
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {taxTariffTrancheList.map((taxTariffTranche, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/tax-tariff-tranche/${taxTariffTranche.id}`} color="link" size="sm">
                      {taxTariffTranche.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.TaxTariffType.${taxTariffTranche.type}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${taxTariffTranche.productType}`} />
                  </td>
                  <td>{taxTariffTranche.trancheLowerBound}</td>
                  <td>{taxTariffTranche.trancheUpperBound}</td>
                  <td>
                    {taxTariffTranche.productOfferingPrices
                      ? taxTariffTranche.productOfferingPrices.map((val, j) => (
                          <span key={j}>
                            <Link to={`/product-offering-price/${val.id}`}>{val.id}</Link>
                            {j === taxTariffTranche.productOfferingPrices.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tax-tariff-tranche/${taxTariffTranche.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tax-tariff-tranche/${taxTariffTranche.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/tax-tariff-tranche/${taxTariffTranche.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.taxTariffTranche.home.notFound">
                No Tax Tariff Tranches found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TaxTariffTranche;
